<template>
  <div class="multiple-choice-container">
    <v-checkbox
      v-for="choice in question.choices"
      :key="choice.id"
      v-model="selectedChoices"
      class="ma-0 mb-5 pa-0"
      :value="choice.id"
      hide-details
      :color="getAssets.colors.form.buttonBackground"
      @change="handleChange"
    >
      <template #label>
        <span class="choice-title">{{ choice.title }}</span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MultipleChoice',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedChoices: []
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    },
    invalidAnswer() {
      return false
    }
  },
  watch: {
    question: {
      handler(newVal) {
        this.selectedChoices = newVal.answers
      },
      deep: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped lang="scss">
.multiple-choice-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 12px;
}

.choice-title {
  font-size: 14px;
  font-weight: normal;
  color: #6b7580;
}
</style>
